import * as React from "react";

function SvgIcYoutube(props) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M18.7803 7.42684C19.0198 7.6663 19.1923 7.96432 19.2808 8.29121C19.7901 10.3414 19.6724 13.5795 19.2907 15.7088C19.2022 16.0357 19.0297 16.3337 18.7902 16.5732C18.5507 16.8126 18.2527 16.9852 17.9258 17.0736C16.7291 17.4 11.9126 17.4 11.9126 17.4C11.9126 17.4 7.09616 17.4 5.89945 17.0736C5.57256 16.9852 5.27455 16.8126 5.03509 16.5732C4.79563 16.3337 4.62308 16.0357 4.53462 15.7088C4.02231 13.6675 4.16275 10.4275 4.52473 8.3011C4.61319 7.97421 4.78574 7.67619 5.0252 7.43673C5.26466 7.19727 5.56267 7.02472 5.88956 6.93627C7.08627 6.60989 11.9028 6.6 11.9028 6.6C11.9028 6.6 16.7192 6.6 17.9159 6.92637C18.2428 7.01483 18.5408 7.18738 18.7803 7.42684ZM14.3654 12L10.3698 14.3143V9.68571L14.3654 12Z" fill="currentColor"/>
        </svg>
    );
}

export default SvgIcYoutube;
